// extracted by mini-css-extract-plugin
export var aboveInput = "_lp-0";
export var actionButton = "_lp-5";
export var actionButtonContainer = "_lp-1";
export var actionIcon = "_lp-6";
export var aiInfoContainer = "_lp-2";
export var attachmentWrapper = "_lp-7";
export var bold = "_lp-3";
export var checkIcon = "_lp-8";
export var clickingRecipientBar = "_lp-11";
export var commentThreadSwitch = "_lp-a";
export var draftImage = "_lp-b";
export var draftImageContainer = "_lp-c";
export var draftImages = "_lp-e";
export var editButton = "_lp-g";
export var editor = "_lp-f";
export var editorContainer = "_lp-y";
export var editorErrorTooltipWrapper = "_lp-9";
export var headerDivider = "_lp-h";
export var icon = "_lp-i";
export var info = "_lp-j";
export var internal = "_lp-n";
export var internalDivider = "_lp-k";
export var internalMessage = "_lp-l";
export var messageInputCard = "_lp-m";
export var messageInputForm = "_lp-o";
export var messageInputFormInternal = "_lp-p";
export var options = "_lp-q";
export var publicMessageCustomer = "_lp-s";
export var publicMessageMerchant = "_lp-r";
export var removeImageButton = "_lp-d";
export var replyButtons = "_lp-t";
export var showSignatureButton = "_lp-u";
export var spinner = "_lp-v";
export var verticalButtonDivider = "_lp-4";
export var visibilitySelector = "_lp-w";
export var warning = "_lp-x";
export var wrappingText = "_lp-z";
export var writingInternalNoteTopBorder = "_lp-10";